var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"913947343cb2fd1ca6a02ce6e5e56c82f79338ae"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["hirefly-web-client@hirefly"]={id:"913947343cb2fd1ca6a02ce6e5e56c82f79338ae"};
      